module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "El-Gouna.3401408b.jpeg" + "?" + Date.now();